import React from 'react';
import { Document, Page, View, Text } from '@react-pdf/renderer';
import { pdfSharedStyles } from './pdfSharedStyles';

interface PlaceholderPdfDocumentProps {
    message?: string;
    title?: string;
}

const PlaceholderPdfDocument: React.FC<PlaceholderPdfDocumentProps> = ({ message = 'Data not available for PDF generation', title = 'PDF Generation Error' }) => {
    return (
        <Document>
            <Page size="A4" style={pdfSharedStyles.page}>
                <View style={pdfSharedStyles.section}>
                    <Text style={[pdfSharedStyles.title, { textAlign: 'center', marginTop: 100 }]}>{title}</Text>
                    <Text style={[pdfSharedStyles.projectInfoSubtitle, { textAlign: 'center', marginTop: 50 }]}>{message}</Text>
                </View>
            </Page>
        </Document>
    );
};

export default PlaceholderPdfDocument;
